import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import _ from "underscore"
import { ToastContext } from "../../../context/ToastContext";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { getFullMonthSelected } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";

export const usePrecisionReport = () => {

    const { showInfo } = useContext(ToastContext)
    const [defaultColDef] = useState([
        {
            field: "manager_name",
            headerName: "Manager Name",
            width: 150,
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "Employee Name",
            width: 150,
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "primary_project",
            headerName: "Major Focused Projects",
            width: 150,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "secondary_project",
            headerName: "Other Minor Projects",
            width: 150,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
    ])
    const [PRColDef] = useState([
        {
            field: "manager_name",
            headerName: "Manager Name",
            width: 150,
            headerClass: "header-wrap",
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "Employee Name",
            width: 150,
            headerClass: "header-wrap",
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "primary_project",
            headerName: "Major Focused Projects",
            width: 150,
            headerClass: "header-wrap",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "secondary_project",
            headerName: "Other Minor Projects",
            width: 150,
            headerClass: "header-wrap",
            cellRenderer: (params) => {
                return (
                    <div title={params?.value || ""}>{params?.value || ""}</div>
                )
            }
        },
        {
            field: "bu_rank",
            headerName: "BU Rank",
            width: 70,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "db_eff_rank",
            headerName: "DB Eff. Rank",
            width: 70,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "tech_rank",
            headerName: "Tech Eff. Rank",
            width: 70,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "time_efficiency_rank",
            headerName: "Time Eff. Rank",
            width: 70,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "remark",
            headerName: "Remarks (SWOT)",
            children: [
                {
                    field: "strength",
                    headerName: "Strength",
                    width: 70,
                    cellStyle: { textAlign: "center" },
                    headerClass: "header-wrap",
                    cellRenderer: (params) => {
                        return (
                            <div title={params?.value || ""}>{params?.value || ""}</div>
                        )
                    }
                },
                {
                    field: "weakness",
                    headerName: "Weakness",
                    width: 70,
                    cellStyle: { textAlign: "center" },
                    headerClass: "header-wrap",
                    cellRenderer: (params) => {
                        return (
                            <div title={params?.value || ""}>{params?.value || ""}</div>
                        )
                    }
                },
                {
                    field: "opportunity",
                    headerName: "Opportunity",
                    width: 70,
                    cellStyle: { textAlign: "center" },
                    headerClass: "header-wrap",
                    cellRenderer: (params) => {
                        return (
                            <div title={params?.value || ""}>{params?.value || ""}</div>
                        )
                    }
                },
                {
                    field: "threat",
                    headerName: "Threat",
                    width: 70,
                    cellStyle: { textAlign: "center" },
                    headerClass: "header-wrap",
                    cellRenderer: (params) => {
                        return (
                            <div title={params?.value || ""}>{params?.value || ""}</div>
                        )
                    }
                },
            ]
        },
        {
            field: "overall_standing_rank",
            headerName: "Overall Rank",
            width: 70,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
    ]);
    const [TEColDef, setTEColDef] = useState(defaultColDef);
    const [PRRowData, setPRRowData] = useState([]);
    const [TERowData, setTERowData] = useState([]);
    const [TEBottomRowData, setTEBottomRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [precisionOpts, setPrecisionOpts] = useState({ leads: [], users: [] });
    const [precisionFilterValues, setPrecisionFilterValues] = useState({ lead: [], user: [], date: new Date() });
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        callautopopulate("users", "project_leads", "user_info").then(res => {
            setPrecisionOpts({ leads: _.sortBy(res?.project_leads, "user_display_name"), users: _.sortBy(res?.users, "user_display_name"), all_users: res?.users });
            const user = _.findWhere(res?.project_leads, { user_code: res?.user_info?.[0]?.user_code });
            setPrecisionFilterValues((prev) => ({ ...prev, lead: [user] }));
            getPrecisionReport([user]);
        })
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!_.isEmpty(precisionFilterValues?.lead)) {
            let filteredUsers = [];
            precisionFilterValues?.lead?.forEach((item) => {
                const findData = _.filter(precisionOpts?.all_users, (user) => user?.reporting_employee_id === item?.employee_id);
                filteredUsers = filteredUsers?.concat(findData);
            })
            setPrecisionOpts((prev) => ({ ...prev, users: _.sortBy(filteredUsers, "user_display_name") }));
        } else {
            setPrecisionOpts((prev) => ({ ...prev, users: _.sortBy(precisionOpts?.all_users, "user_display_name") }));
        }
    }, [precisionFilterValues?.lead])

    const getPrecisionReport = async (lead, user, date) => {
        try {
            setLoader(true);
            const project_lead = lead ? _.pluck(lead, "user_code")?.toString() : _.pluck(precisionFilterValues?.lead, "user_code")?.toString();
            const selected_user = user ? "" : _.pluck(precisionFilterValues?.user, "user_code")?.toString();
            const selected_date = date ? getFullMonthSelected(date) : getFullMonthSelected(precisionFilterValues?.date);
            const payload = {
                "from_date": selected_date?.from_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "to_date": selected_date?.to_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "users": selected_user,
                "project_lead_user_code": project_lead
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPRECISIONREPORT"), payload);
            if (res) {
                const teamEfforts = res?.body?.data?.team_effort_description;
                const performanceRanking = res?.body?.data?.performance_ranking_description;
                formatTeamEffortData(teamEfforts);
                setPRRowData(_.sortBy(performanceRanking, "manager_name"));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error getting precision report: ", error);
            setLoader(false);
        }
    }

    const formatTeamEffortData = (teamEfforts) => {
        const teamCategories = _.uniq(_.pluck(teamEfforts, "issue_type_name"));
        let totalObj = { manager_name: "Total", user_display_name: "", primary_project: "", secondary_project: "" };
        let teamColDef = [...defaultColDef];
        // set col def
        teamColDef.push({
            field: "working_hours",
            headerName: "Working Hours (h)",
            width: 80,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap",
        })
        teamCategories?.forEach((item) => {
            const obj = {
                field: item,
                headerName: `${item} (h %)`,
                width: 100,
                cellStyle: { textAlign: "center" },
                headerClass: "header-wrap",
            };
            if (_.isEmpty(_.findWhere(teamColDef, { field: item }))) {
                teamColDef.push(obj);
            }

            // initialise total Object
            totalObj[item] = 0;
        })
        teamColDef = teamColDef.concat([
            {
                field: "total_efforts",
                headerName: "Total Efforts (Efficiency h)",
                width: 100,
                cellStyle: { textAlign: "center" },
                headerClass: "header-wrap",
                cellRenderer: (params) => {
                    return (
                        <div>{params?.value !== undefined && `${params?.value}h`}</div>
                    )
                }
            },
            {
                field: "total_efforts_percantage",
                headerName: "Total Efforts (Efficiency %)",
                width: 100,
                cellStyle: { textAlign: "center" },
                headerClass: "header-wrap",
                cellRenderer: (params) => {
                    return (
                        <div>{params?.value !== undefined && `${params?.value}%`}</div>
                    )
                }
            },
        ])

        // set row data
        let teamRowData = [];
        teamEfforts?.map((item) => {
            // set data obj
            let obj = {
                manager_name: item?.manager_name,
                user_display_name: item?.user_display_name,
                primary_project: item?.primary_project,
                secondary_project: item?.secondary_project,
                working_hours: item?.working_hours,
                total_efforts: item?.total_efforts,
                total_efforts_percantage: item?.total_efforts_percantage
            }

            const loggedHours = parseInt(item?.logged_hours?.toString()?.split(".")?.[1]) > 0 ? item?.logged_hours?.toString() : item?.logged_hours?.toString()?.split(".")?.[0];
            const percent = item?.logged_hours_percentage?.toFixed(2);
            const percentString = parseInt(percent?.toString()?.split(".")?.[1]) > 0 ? percent : percent?.toString()?.split(".")?.[0];
            const formattedLogString = `${loggedHours}h (${percentString}%)`

            obj[item?.issue_type_name] = formattedLogString;
            if (_.isEmpty(_.findWhere(teamRowData, { user_display_name: item?.user_display_name }))) {
                teamRowData.push(obj)
            } else {
                const index = _.findIndex(teamRowData, { user_display_name: item?.user_display_name });
                teamRowData[index][item?.issue_type_name] = formattedLogString;
            }
        })

        // calculate Total
        teamCategories?.forEach((item) => {
            teamRowData?.map((row) => {
                if (row[item]) {
                    totalObj[item] += parseFloat(row[item]?.split(" ")?.[0]?.split("h")?.[0]);
                } else {
                    row[item] = "0h (0%)";
                }
            })
            totalObj[item] = parseInt(totalObj[item]?.toString()?.split(".")?.[1]) > 0 ? totalObj[item]?.toFixed(2) + "h" : totalObj[item] + "h";
        })
        totalObj["working_hours"] = 0
        totalObj["total_efforts"] = 0;
        totalObj["total_efforts_percantage"] = 0;
        teamRowData?.forEach((item) => {
            totalObj["working_hours"] += parseFloat(item?.working_hours)
            totalObj["total_efforts"] += item?.total_efforts
            totalObj["total_efforts_percantage"] += item?.total_efforts_percantage
        })
        totalObj.working_hours = totalObj?.working_hours?.toString()

        setTEColDef(teamColDef);
        setTERowData(_.sortBy(teamRowData, 'manager_name'));
        setTEBottomRowData([totalObj]);
    }

    const handleExcelDownload = async () => {
        if (_.isEmpty(TERowData) && _.isEmpty(PRRowData)) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Precision Report');

        // Team Efforts Table
        const teamEffortHeader = _.pluck(TEColDef, "headerName")

        worksheet.addRow(['Team Efforts']).font = { bold: true, size: 14 };
        const headerRow = worksheet.addRow(teamEffortHeader);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        headerRow.height = 30;

        const TEFields = _.pluck(TEColDef, "field");
        const concatedTeamData = TERowData?.concat(TEBottomRowData);
        concatedTeamData.forEach(rowData => {
            let dataArray = [];
            TEFields?.forEach((field) => {
                dataArray.push(rowData[field]);
            })
            const row = worksheet.addRow(dataArray);

            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });

            if (rowData.manager_name === "Total") {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                });
            }
        });

        worksheet.addRow([]);
        worksheet.addRow([]);
        worksheet.addRow([]);

        // Performance Ranking Table

        worksheet.addRow(['Performance Ranking']).font = { bold: true, size: 14 };

        const performanceHeader = _.pluck(PRColDef, "headerName");
        const remarkSubCols = ["Strength", "Weakness", "Opportunity", "Threat"];

        const headerRow1Values = [];
        performanceHeader.forEach(header => {
            if (header === "Remarks (SWOT)") {
                headerRow1Values.push("Remarks (SWOT)", null, null, null);
            } else {
                headerRow1Values.push(header);
            }
        });
        const headerRow1 = worksheet.addRow(headerRow1Values);

        const headerRow2Values = [];
        performanceHeader.forEach(header => {
            if (header === "Remarks (SWOT)") {
                remarkSubCols.forEach(sub => headerRow2Values.push(sub));
            } else {
                headerRow2Values.push(null);
            }
        });
        const headerRow2 = worksheet.addRow(headerRow2Values);

        let colIndex = 1;
        performanceHeader.forEach(header => {
            if (header === "Remarks (SWOT)") {
                worksheet.mergeCells(headerRow1.number, colIndex, headerRow1.number, colIndex + 3);
                colIndex += 4;
            } else {
                worksheet.mergeCells(headerRow1.number, colIndex, headerRow2.number, colIndex);
                colIndex++;
            }
        });

        [headerRow1, headerRow2].forEach(row => {
            row.font = { bold: true };
            row.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            row.eachCell(cell => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        const PRFields = _.pluck(PRColDef, "field");
        PRRowData.forEach(rowData => {
            const dataArray = [];
            PRFields.forEach(field => {
                if (field === "remark") {
                    dataArray.push(rowData?.strength || "");
                    dataArray.push(rowData?.weakness || "");
                    dataArray.push(rowData?.opportunity || "");
                    dataArray.push(rowData?.threat || "");
                } else {
                    dataArray.push(rowData[field] === null ? "" : rowData[field]);
                }
            });

            const row = worksheet.addRow(dataArray);
            row.eachCell(cell => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        let columnWidths = _.pluck(TEColDef, "width");
        columnWidths = columnWidths?.map(item => item / 6);
        worksheet.columns.forEach((col, idx) => {
            col.width = columnWidths[idx] || 18;
        });


        const date = new Date(precisionFilterValues?.date);
        const month = date?.toLocaleString('en-US', { month: 'short' });
        const year = date?.getFullYear();
        const fileName = `${month}_${year}_Precision_Report.xlsx`;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, fileName);
    };

    const handleMonthChange = (val) => {
        const month = parseInt(precisionFilterValues?.date?.getMonth()) + val;
        const newDate = new Date((new Date()).setMonth(month));
        setPrecisionFilterValues((prev) => ({ ...prev, date: newDate }));
        getPrecisionReport(null, null, newDate);
    }


    return useMemo(() => ({
        PRColDef, PRRowData, TEColDef, TERowData, TEBottomRowData, loader, handleExcelDownload, precisionOpts, precisionFilterValues, setPrecisionFilterValues, handleMonthChange, isChanged, setIsChanged, getPrecisionReport
    }), [PRColDef, PRRowData, TEColDef, TERowData, TEBottomRowData, loader, handleExcelDownload, precisionOpts, precisionFilterValues, setPrecisionFilterValues, handleMonthChange, isChanged, setIsChanged, getPrecisionReport])
}